import React from 'react';
import { ListItemIcon, Typography } from '@material-ui/core';
import GavelIcon from '@material-ui/icons/Gavel';
import { useTranslation } from 'react-i18next';
import { themeColors } from '../../constants';
import { IRouteProps } from '../../types';

export default function MuiMenuImpressum(props: IRouteProps) {
  const { t } = useTranslation();
  return (
    <div style={props.isActive ? { color: themeColors.yellow } : {}}>
      <ListItemIcon>
        <GavelIcon fontSize="small" />
      </ListItemIcon>
      <Typography variant="inherit">{t('navigation.impressum')}</Typography>
    </div>
  );
}
